import { render, staticRenderFns } from "./SilderBar.vue?vue&type=template&id=0bbbbc88&scoped=true"
import script from "./SilderBar.vue?vue&type=script&lang=ts"
export * from "./SilderBar.vue?vue&type=script&lang=ts"
import style0 from "./SilderBar.vue?vue&type=style&index=0&id=0bbbbc88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbbc88",
  null
  
)

export default component.exports